import { render } from "./AlertDontHide.vue?vue&type=template&id=52a50840&scoped=true&ts=true"
import script from "./AlertDontHide.vue?vue&type=script&lang=ts"
export * from "./AlertDontHide.vue?vue&type=script&lang=ts"

import "./AlertDontHide.vue?vue&type=style&index=0&id=52a50840&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a50840"]])

export default __exports__